<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <div class="card">
      <div class="card-body row">
        <MenuCard
          v-for="menu in menuList"
          :key="menu.key"
          hasHoverEffect
          :title="menu.title"
          :description="menu.desc"
          @click="$router.push({ name: menu.pathName })"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import MenuCard from './components/MenuCard'

import menuList from './lib/menu-list'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    MenuCard,
  },
  data() {
    return {
      menuList,
    }
  },
  computed: {
    title() {
      return this.$t('setting.homePage.tokenApi')
    },
    subTitle() {
      return this.$t('setting.homePage.textTokenApi')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.development.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.tokenApi'),
        },
      ]
    },
  },
}
</script>
